import generalConfig from '@/config/general';
export default {
  containerQueryPolyfillSrc: 'https://cdn.jsdelivr.net/npm/container-query-polyfill@1/dist/container-query-polyfill.modern.js',
  containerQueryPolyfillVarName: `${generalConfig.productName}_container_queries`.toUpperCase()
};